module.exports = __webpack_public_path__ + "media/images/flags/lb-806e6e3f361f000a504747b2395db843.svg";